import * as Yup from "yup";

const PurchaseModalValidationSchema = Yup.object().shape({
  itemId: Yup.string().required("Product is required"),
  quantity: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .required("Quantity is required")
    .positive("Quantity must be positive")
    .typeError("Quantity must be a number"),
  purchaseRate: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .required("Rate is required")
    .positive("Rate must be positive")
    .typeError("Rate must be a number"),
});

export default PurchaseModalValidationSchema;
